<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
import { RadioGroupRoot } from 'reka-ui'
import { storeToRefs } from 'pinia'
import useLicenseControlStore from '~/stores/licenseControl'
import { useAuthStore } from '~/stores/auth'
import Button from '~/components/ui/Button.vue'
import AuRadio from '~/components/ui/AuRadio.vue'

const { t } = useI18n()
const authStore = useAuthStore()
const licenseStore = useLicenseControlStore()

const { userOrganization, userOrganizations } = storeToRefs(authStore)
const { content } = storeToRefs(licenseStore)

const selectedOrgNumber = computed({
  get: () => userOrganization.value?.number,
  set: async (orgNumber) => {
    const org = userOrganizations.value.find(o => o.number === orgNumber)
    if (!org)
      return

    await authStore.updateUserOrganization(org)
    if (content.value) {
      await licenseStore.checkItemLicense(content.value)
    }
  }
})
</script>

<template>
  <div>
    <p class="text-gray-50" v-text="t('organization.title')" />
    <RadioGroupRoot
      v-model="selectedOrgNumber"
      as="fieldset"
      class="mt-6 flex flex-wrap gap-2"
    >
      <Button
        v-for="org in userOrganizations"
        :key="org.number"
        variant="outline"
        type="label"
      >
        <AuRadio shade="dark" :value="org.number" />
        {{ org.name }}
      </Button>
    </RadioGroupRoot>
  </div>
</template>
